/**
 * Two tiny stat cards rendered side-by-side in the main dashboard grid.
 * Kept in one file because they share presentation and are always used
 * together.
 */
import React from 'react';
import { Card } from '../ui/card';
import { Shop, Group } from 'iconoir-react';
import { formatCurrency } from './constants';

export function VendorsStatCard({ summary, currency }) {
  return (
    <Card className="card-surface p-6" data-testid="vendors-stat-card">
      <div className="flex items-center justify-between mb-3">
        <Shop className="w-5 h-5 text-ochre" strokeWidth={1.5} />
        <span className="text-xs text-muted uppercase tracking-wider">Vendors</span>
      </div>
      <p className="font-mono text-3xl text-charcoal">{summary?.total_vendors || 0}</p>
      <p className="text-xs text-muted mt-1">
        {formatCurrency(summary?.remaining, currency)} unpaid
      </p>
    </Card>
  );
}

export function GuestsStatCard({ summary }) {
  return (
    <Card className="card-surface p-6" data-testid="guests-stat-card">
      <div className="flex items-center justify-between mb-3">
        <Group className="w-5 h-5 text-moss" strokeWidth={1.5} />
        <span className="text-xs text-muted uppercase tracking-wider">Guests</span>
      </div>
      <p className="font-mono text-3xl text-charcoal">{summary?.total_attendees || 0}</p>
      <p className="text-xs text-muted mt-1">{summary?.confirmed || 0} confirmed</p>
    </Card>
  );
}
